/* eslint-disable @typescript-eslint/no-unused-vars */
import { createMachine, assign, DoneInvokeEvent } from 'xstate';
import { Division } from '@chargify/data-access';

import { NO_STATE_OPTION } from '../../constants';
import { Context, Events } from './types';

export const initialContext: Context = {
  countries: [],
  subdivisions: [],
};

const addressMachine = createMachine<Context, Events>({
  id: 'addressMachine',
  predictableActionArguments: true,
  context: initialContext,
  type: 'parallel',
  states: {
    country: {
      initial: 'idle',
      states: {
        idle: {
          on: {
            FETCH_COUNTRY: {
              target: 'fetching',
            },
          },
        },
        fetching: {
          invoke: {
            id: 'fetchCountries',
            src: 'getCountries',
            onDone: {
              target: 'idle',
              actions: [
                assign(
                  (_ctx, event: DoneInvokeEvent<{ items: Division[] }>) => ({
                    countries: event.data.items,
                  })
                ),
              ],
            },
            onError: {
              target: 'error',
            },
          },
        },
        error: {},
      },
    },
    subdivision: {
      initial: 'idle',
      states: {
        idle: {
          on: {
            FETCH_SUBDIVISION: {
              target: 'fetching',
            },
          },
        },
        fetching: {
          invoke: {
            id: 'fetchSubdivisions',
            src: 'getSubdivisions',
            onDone: {
              target: 'idle',
              actions: [
                assign(
                  (_ctx, event: DoneInvokeEvent<{ items: Division[] }>) => ({
                    subdivisions: event.data.items,
                  })
                ),
              ],
            },
            onError: {
              target: 'idle',
              actions: [
                assign((_ctx, event) => ({
                  subdivisions: [NO_STATE_OPTION],
                })),
              ],
            },
          },
        },
        error: {},
      },
    },
  },
});

export { addressMachine };
